import { useTranslation } from 'react-i18next'
import { ScrollFade } from '@/components/ScrollFade'
import { HeroGraph } from './HeroGraph'
import { track } from '@/lib/analytics'
import { SOFT_LAUNCH } from '@/lib/launchMode'

export function Hero() {
  const { t } = useTranslation()

  const onSeeItWork = () => {
    track('hero_secondary_cta_clicked', {})
    document.getElementById('live-demo')?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <section className="max-w-7xl mx-auto px-5 md:px-8 pt-12 md:pt-24 pb-12">
      <div className="grid md:grid-cols-2 gap-10 items-center">
        <div className="order-2 md:order-1">
          <ScrollFade as="h1" className="text-5xl md:text-7xl font-bold font-display leading-[1.05]">
            {t('lorem:hero.headline')}
          </ScrollFade>
          <ScrollFade as="p" className="mt-5 text-base md:text-lg opacity-75 max-w-prose" delay={120}>
            {t('lorem:hero.subline')}
          </ScrollFade>
          <ScrollFade as="div" className="mt-8 flex flex-wrap gap-3" delay={240}>
            <a
              href="#early-access"
              className="pr-5 py-2.5 rounded-md text-sm font-medium
                bg-mono-800 text-mono-100 dark:bg-mono-100 dark:text-mono-900
                marker-dot"
              onClick={() => track('hero_cta_clicked', { variant: 'primary' })}
            >
              {t('hero.ctaPrimary')}
            </a>
            {!SOFT_LAUNCH && (
              <button
                type="button"
                onClick={onSeeItWork}
                className="pr-5 py-2.5 rounded-md text-sm font-medium border border-mono-400 dark:border-mono-700
                  marker-dot"
              >
                {t('hero.ctaSecondary')}
              </button>
            )}
          </ScrollFade>
        </div>
        <ScrollFade as="div" className="order-1 md:order-2 text-mono-700 dark:text-mono-200">
          <HeroGraph />
        </ScrollFade>
      </div>
    </section>
  )
}
